﻿import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ssApiService } from './ss-api.service';
import { GlobalService } from './global.service';


@Injectable()
export class AuthGuardService implements CanActivate {

    constructor(private authService: AuthService, private router: Router, private api: ssApiService, private gb: GlobalService) {  }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

        this.gb.ReadFromStorage();

        if ( this.gb.Token != undefined && this.gb.Token != '' && this.gb.TokenExpiration != undefined && this.gb.TokenExpiration > new Date() ) {
            return true;
        }else {
            localStorage.setItem('loginRedirect', state.url)
            console.log("lr1");
            this.router.navigate(['/authentication']);
        }

    }

}
